
var fitt = require('fitt'),
encURIComp = fitt.encURIComp,
cstr = fitt.cstr,
cnum = fitt.cnum,
isObj = fitt.isObj,
owns = fitt.owns,
default_headers = {
	'Content-Type': 'application/x-www-form-urlencoded' };


var JSON_EXP = /\bjson\b/,
FORM_EXP = /\bx-www-form-urlencoded\b/;

function getDispatch(descriptor) {
	var dispatch;
	if (process.browser) {
		// For browsers use XHR
		dispatch = require('../dispatch/xhr.js');
	} else {
		// For node use HTTP or mock loader
		if (descriptor === 'mock') {
			dispatch = require('../dispatch/mock.js');
		} else {
			dispatch = require('../dispatch/http.js');
		}
	}
	return dispatch;
}

function transformJSON(data, headers) {
	var contentTypeHeader = cstr(headers && headers['content-type']),
	isJSON = contentTypeHeader && JSON_EXP.test(contentTypeHeader);

	if (data && !isObj(data) && isJSON) {
		return JSON.parse(data);
	}
	return data;
}

function transformHeaderData(data, headers) {
	var contentTypeHeader = cstr(headers && headers['Content-Type']),
	str = [],
	p,pval;

	if (contentTypeHeader && FORM_EXP.test(contentTypeHeader)) {
		for (p in data) {
			pval = owns(data, p) ? cstr(data[p]) : '';
			if (pval) {
				str.push(encURIComp(p) + "=" + encURIComp(pval));
			}
		}
		return str.join("&");
	}
	return data;
}

if (typeof module !== fitt.TYPE_UNDEF) {
	module.exports = {

		getDispatch: getDispatch,

		headers: {
			'Accept': 'application/json, text/plain, */*' },


		method: 'GET',

		method_headers: {
			patch: default_headers,
			post: default_headers,
			put: default_headers },


		timeout: process.browser ? 5000 : 3000,

		tracing: false,

		transformRequest: [transformHeaderData],

		transformResponse: [transformJSON],

		validateResponse: function (response) {
			var httpConfig = response && response.config,
			httpMethod = cstr(httpConfig && httpConfig.method),
			httpStatus = cnum(response && response.status, 0),
			ret = false;

			if (httpMethod === 'head') {
				ret = httpStatus === 404;
			} else {
				ret = httpStatus >= 200 && httpStatus < 300;
			}
			return ret;
		} };

}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/defaults.js
// module id = 815
// module chunks = 0